/**
 * Markdown — rendered model output, shared by the review chat's assistant
 * bubbles and the transcript's assistant rows.
 *
 * Element styles live here because there is no typography plugin: the
 * handful of tags models actually emit are styled with semantic tokens.
 * For ASSISTANT text only — user/system/harness text renders verbatim,
 * since markdown rendering would mangle its <TAG>-style scaffolding.
 */

import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { chatMarkdown } from './chatMarkdown'

export type { Components as MarkdownComponents }

export const MARKDOWN_STYLES = [
  '[&_p]:my-1.5 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
  '[&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5',
  '[&_li]:my-0.5',
  '[&_code]:bg-muted [&_code]:px-1 [&_code]:font-mono [&_code]:text-[0.85em]',
  '[&_pre]:my-1.5 [&_pre]:overflow-x-auto [&_pre]:bg-muted [&_pre]:p-2 [&_pre_code]:bg-transparent [&_pre_code]:p-0',
  '[&_h1]:mt-2 [&_h1]:font-serif [&_h1]:text-base [&_h2]:mt-2 [&_h2]:font-serif [&_h2]:text-base [&_h3]:mt-2 [&_h3]:font-serif [&_h3]:text-sm',
  '[&_table]:my-1.5 [&_table]:w-full [&_table]:border-collapse [&_th]:border [&_th]:border-border [&_th]:px-1.5 [&_th]:py-0.5 [&_th]:text-left [&_td]:border [&_td]:border-border [&_td]:px-1.5 [&_td]:py-0.5',
  '[&_blockquote]:my-1.5 [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-2 [&_blockquote]:text-muted-foreground',
  '[&_a]:underline [&_a]:underline-offset-2',
].join(' ')

export function Markdown({
  text,
  className = '',
  components,
}: {
  text: string
  className?: string
  /** Per-tag overrides (the ask panel swaps `a` for its request links). */
  components?: Components
}): React.JSX.Element {
  return (
    <div className={`${MARKDOWN_STYLES} ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {chatMarkdown(text)}
      </ReactMarkdown>
    </div>
  )
}
